export { BlueBeetlePage as default, getServerSideProps } from 'src/features/BlueBeetle';
